import axiosInstance from "./axiosInstance";
import { axiosInstanceFast } from "./axiosInstance";
import {
  managedUsersQueryProps,
  unmanagedUsersQueryProps,
} from "@pages/homepage/identityIntelligence/identityIntelligenceType";

//Dummy data
import * as dummy from "@pages/homepage/identity-posture/dummyData";
import * as dummyData from "@pages/homepage/identityIntelligence/dummydata";

//Using the old users list to get the users in watchlist. Later will be changed to the new API specifically for watchlist
export const identityIntelligenceOld = async (
  filterTime: string,
  signal?: AbortSignal,
) => {
  const response = await axiosInstance.post(
    "/identityIntelligence/",
    {
      filterTime,
    },
    { signal },
  );
  return response.data.data;
};

export const deleteUser = async (data: {
  username: string;
  source?: string;
  subSource?: string;
  tenantId?: string;
}) => {
  const response = await axiosInstanceFast.delete("/user/delete/", {
    data: {
      username: data.username,
      source: data.source,
      subSource: data.subSource,
      tenantId: data.tenantId || null,
      isSoftDelete: true,
    },
  });
  return response.data;
};

export const identityIntelligence = async (
  filterTime: string,
  signal?: AbortSignal,
  filter_user?: any,
) => {
  const payload = {
    filterTime: filterTime,
    filter_user: filter_user || [],
  };
  const response = await axiosInstanceFast.post("/user/all-data", payload, {
    signal,
  });
  return response.data.data;
};

export const dormantUsers = async (
  signal?: AbortSignal,
  sub_source?: string[],
  filter_user?: Record<string, string>,
) => {
  const payload = {
    sub_source: sub_source || [],
    filter_user: filter_user || {},
  };
  const response = await axiosInstanceFast.post(
    "/user/dormant-users",
    payload,
    { signal },
  );
  return response.data.data;
};

export const identityIntelligenceUsers = async (signal?: AbortSignal) => {
  const data = { filterTime: "day", userLimit: 0, startUser: 0, endUser: 0 };
  const response = await axiosInstance.post(
    "/identityIntelligenceUsers/",
    data,
    { signal },
  );
  return response.data;
};

export const usersCURD = async (filterTime: string, signal?: AbortSignal) => {
  const response = await axiosInstance.post(
    "/statusfilter/",
    {
      filterTime: filterTime,
      filterType: "identityIntelligence",
    },
    { signal },
  );
  return response.data;
};

export const unmanagedUsersOld = async (signal?: AbortSignal) => {
  const response = await axiosInstance.post(
    "/identityIntelligenceNonADUsers/",
    { filterTime: "day" },
    { signal },
  );
  return response.data;
};

export const managedUsers = async (
  data: managedUsersQueryProps,
  signal?: AbortSignal,
) => {
  const response = await axiosInstanceFast.post("/user/users", data, {
    signal,
  });
  return response.data.data;
};

export const unmanagedUsers = async (
  data: unmanagedUsersQueryProps,
  signal?: AbortSignal,
) => {
  const response = await axiosInstanceFast.post("/user/non-ad-users", data, {
    signal,
  });
  return response.data.data;
};

export const watchlistUsers = async (
  filterTime: string = "day",
  signal?: AbortSignal,
) => {
  const response = await axiosInstanceFast.get(
    "user/get-watchlist?filterTime=" + filterTime,
    {
      signal,
    },
  );
  return response.data.data;
};

export const getOrganizationUnits = async (signal?: AbortSignal) => {
  const response = await axiosInstanceFast.post("/itdr/organizational-units", {
    signal,
  });
  return response.data.data;
};

export const getOrganizationUnitsList = async (
  data: {
    page: number;
    limit: number;
    search_columns: string[];
    search_text: string;
    sort_key: string;
    sort_order: string;
  },
  signal?: AbortSignal,
) => {
  const response = await axiosInstanceFast.post(
    "/groups/organizational-units-list",
    data,
    {
      signal,
    },
  );
  return response.data;
};

export const usersSource = async (signal?: AbortSignal) => {
  const response = await axiosInstanceFast.get("/user/get-sources", {
    signal,
  });
  return response.data;
};

export const userLocation = async (signal?: AbortSignal) => {
  const currenttime = Math.floor(new Date().getTime() / 1000);
  const lastday = currenttime - 60 * 60 * 24 * 30;
  const response = await axiosInstanceFast.get(
    `/itdr/user-logins/?start_time=${lastday}&end_time=${currenttime}`,
    {
      signal,
    },
  );
  return response.data.data;
};

export const getAccountsExpiringSoon = async (
  mappedAccountExpirySoonFilters: Record<string, string>,
  sub_source: string[],
  signal?: AbortSignal,
) => {
  const payload = {
    sub_source: sub_source || [],
    filter_user: mappedAccountExpirySoonFilters,
  };
  const response = await axiosInstanceFast.post(
    "itdr/password-expiry-in15days-users",
    payload,
    { signal },
  );
  return response.data.data;
};

export const getSuperUsers = async (
  mappedSuperUserFilters: Record<string, string>,
  sub_source: string[],
  signal?: AbortSignal,
) => {
  const payload = {
    sub_source: sub_source || [],
    filter_user: mappedSuperUserFilters,
  };
  const response = await axiosInstanceFast.post("/user/admin-users", payload, {
    signal,
  });
  return response.data;
};

export const getTopSecurityGroups = async (signal?: AbortSignal) => {
  const response = await axiosInstanceFast.post("/itdr/security-groups", {
    signal,
  });
  return response.data;
};

export const getSecurityGroupList = async (
  payload: any,
  signal?: AbortSignal,
) => {
  const response = await axiosInstanceFast.post(
    "/groups/security-members-list",
    payload,
    {
      signal,
    },
  );
  return response.data;
};

export const getTopRoles = async (signal?: AbortSignal) => {
  const response = await axiosInstanceFast.get("/itdr/top-roles", {
    signal,
  });
  return response.data.data;
};

export const getUserGrowth = async (signal?: AbortSignal) => {
  const response = await axiosInstanceFast.get("/user/user-growth", {
    signal,
  });
  return response.data.data;
};

export const getTopGroups = async (signal?: AbortSignal) => {
  const response = await axiosInstanceFast.get("/itdr/top-groups", {
    signal,
  });
  return response.data.data;
};

export const getUserCreated = async (
  filter_time: string,
  signal?: AbortSignal,
) => {
  const response = await axiosInstanceFast.post(
    "/user/user-created",
    { filterTime: filter_time },
    { signal },
  );
  return response.data.data;
};

export const getUserLocked = async (signal?: AbortSignal) => {
  const response = await axiosInstanceFast.post("/user/user-locked", {
    signal,
  });
  return response.data.data;
};

export const getNoPasswordExpiry = async (
  mappedNoPswdExpiryFilters: Record<string, string>,
  sub_source: string[],
  signal?: AbortSignal,
) => {
  const payload = {
    sub_source: sub_source || [],
    filter_user: mappedNoPswdExpiryFilters,
  };

  const response = await axiosInstanceFast.post(
    "/itdr/no-password-expiry-users",
    payload,
    { signal },
  );
  return response.data;
};

interface FilterUser {
  isSuperUser: string;
  isLocked: string;
  isUnlocked: string;
  isEnabled: string;
  isDisabled: string;
}

export const getNoPasswordUsers = async (data: {
  sub_source: string[];
  filter_user: FilterUser;
}) => {
  const response = await axiosInstanceFast.post(
    "/itdr/no-password-users",
    data,
  );
  return response.data.data;
};

//Mutations
// export const updateUserData = async (data: {
//   account: string;
//   watched?: number;
//   serviceAccount?: number;
//   critical?: number;
//   whitelist?: number;
// }) => {
//   const response = await axiosInstanceFast.post("/user/user-details/", data);
//   return response.data;
// };

interface userAttributeUpdateProps {
  name: string;
  value: string;
  isCustom: boolean;
  metadata?: {
    time_seen: number;
    source: string;
    sub_source: string;
  };
}

export const updateUserAttribute = async (data: {
  username: string;
  source?: string;
  subSource?: string;
  tenantId?: string;
  attributes: userAttributeUpdateProps[];
}) => {
  const response = await axiosInstanceFast.put(
    "/user/update-attributes/",
    data,
  );
  return response.data;
};

export const setAdCriticalStatus = async (data: {
  account: string;
  critical: number;
}) => {
  const response = await axiosInstance.post("/adgroupdetails/", data);
  return response.data;
};

export const identityIntelligenceFullData = async (
  widgetName: string,
  signal: AbortSignal,
) => {
  const response = await axiosInstance.post(
    "/identityIntelligenceFullData/",
    {
      widgetName: widgetName,
    },
    { signal },
  );
  return response.data;
};

export const securityMembersList = async (
  params: UserWidgetParams,
  signal: AbortSignal,
) => {
  const payload = {
    page: params.page,
    limit: params.limit,
    search_text: params.search_text ?? " ",
    sort_key: params.sort_key ?? " ",
    sort_order: "desc",
  };

  const response = await axiosInstanceFast.post(
    "/groups/security-members-list",
    payload,
    { signal },
  );

  return response.data;
};
interface UserWidgetParams {
  page: number;
  limit: number;
  search_columns?: string[];
  search_text?: string;
  sort_key?: string;
  sort_order?: string;
}

export const usersWidgetDrillDown = async (
  widget_id: string,
  params: UserWidgetParams,
  signal: AbortSignal,
) => {
  const payload = {
    page: params.page,
    limit: params.limit,
    widget_id: widget_id,
    search_columns: params.search_columns ?? "",
    search_text: params.search_text ?? " ",
    sort_key: params.sort_key ?? " ",
    sort_order: "desc",
  };

  const response = await axiosInstanceFast.post(
    "/itdr/users_widget_drill_down",
    payload,
    { signal },
  );
  return response.data;
};

export const getGroupList = async (data: any) => {
  const response = await axiosInstanceFast.post("/groups/groups-list", data);
  return response.data;
};

export const azureGroupUsersFullData = async (
  widgetName: string,
  source: string,
  key: string,
  signal?: AbortSignal,
) => {
  const response = await axiosInstance.post(
    "/azureGroupUsersFullData/",
    {
      widgetName: widgetName,
      source: source,
      key: key,
    },
    { signal },
  );
  return response.data;
};

// export const getTopGroups = async (signal?: AbortSignal) => {
//   const response = await axiosInstanceFast.get("itdr/top-groups", {
//     signal,
//   });
//   return response.data.data;
// };

// export const getTopRoles = async (signal?: AbortSignal) => {
//   const response = await axiosInstanceFast.get("itdr/top-roles", {
//     signal,
//   });
//   return response.data.data;
// };

export const getUserRiskStatusData = async () => {
  return dummy.userRiskStatusData;
};

function getMonthBackEpoch() {
  const date = new Date();
  const time = date.getTime() - 60 * 60 * 24 * 15 * 1000;
  return Math.floor(time / 1000);
}

export const getAuthOverTime = async () => {
  const startTime = getMonthBackEpoch();
  const endTime = Math.floor(new Date().getTime() / 1000);
  const response = await axiosInstanceFast.get(
    `/itdr/authentication-over-time?start_time=${startTime}&end_time=${endTime}`,
  );
  return response.data.data;
};

export const getAuthProtocol = async () => {
  const startTime = getMonthBackEpoch();
  const endTime = Math.floor(new Date().getTime() / 1000);
  const response = await axiosInstanceFast.get(
    `/itdr/authentication-protocols?start_time=${startTime}&end_time=${endTime}`,
  );
  return response.data.data;
  // return dummy.authenticationProtocolDummyData;
};

export const getUserCRUDData = async () => {
  const startTime = getMonthBackEpoch();
  const endTime = Math.floor(new Date().getTime() / 1000);
  const response = await axiosInstanceFast.get(
    `/itdr/recent-activity?start_time=${startTime}&end_time=${endTime}`,
  );
  return response.data.data;
};

export const getUserAuditData = async (timeframe: string) => {
  const response = await axiosInstanceFast.get(
    `/itdr/get-user-audit-data?filterTime=${timeframe}`,
  );
  return response.data.data;
};

export const getGroups = async (
  data: {
    page: number;
    limit: number;
    search_columns: string[];
    search_text: string;
    sort_key: string;
    sort_order: string;
  } = {
    page: 0,
    limit: 10,
    search_columns: [],
    search_text: "",
    sort_key: "",
    sort_order: "asc",
  },
  signal?: AbortSignal,
) => {
  const response = await axiosInstanceFast.post("/groups/groups-list", data, {
    signal,
  });
  return response.data;
};

export const getGroupMembers = async (
  data: {
    group_uid: string;
    member_type: string;
    page: number;
    limit: number;
  } = { group_uid: "", member_type: "user", page: 0, limit: 10 },
  signal?: AbortSignal,
) => {
  const response = await axiosInstanceFast.post(
    "/itdr/users-by-group-uid",
    data,
    { signal },
  );
  return response.data;
};

export const getGroupDetails = async (
  data: {
    group_uid: string;
    plugin_id: string;
    page: number;
    limit: number;
    for_ui: boolean;
  } = { group_uid: "", plugin_id: "", page: 0, limit: 10, for_ui: true },
  signal?: AbortSignal,
) => {
  const response = await axiosInstanceFast.post(
    "/groups/group-members-list",
    data,
    { signal },
  );
  return response.data;
};

export const getUserAnomaliesByType = async (
  filterTime: string = "day",
  signal?: AbortSignal,
) => {
  const response = await axiosInstanceFast.post(
    "user/user-anomalies-by-type?filterTime=" + filterTime,
    {},
    { signal },
  );
  return response.data.data;
};

export const getEmptyGroups = async (signal?: AbortSignal) => {
  const response = await axiosInstanceFast.post(
    "/groups/groups-with-no-members",
    {},
    { signal },
  );
  return response.data.data;
};

export const getUserAttributes = async (signal?: AbortSignal) => {
  const response = await axiosInstanceFast.get("/user/attributes", {
    signal,
  });
  return response.data.data;
};

// export const changeUserAttribute = async (data: any) => {
//   const response = await axiosInstanceFast.put(
//     "/user/update-attributes/",
//     data,
//   );
//   return response.data.data;
// };

export const getTopActiveLoginPAM = async () => {
  return dummyData.topActiveUserLoginsFromPAM;
};

export const getTopDeniedAccessesByUser = async () => {
  return dummyData.topDeniedAccessesByUser;
};

export const getLogonFailedEvents = async () => {
  return dummyData.logonFailedEvents;
};

export const getAccountSecretsByType = async () => {
  return dummyData.accountSecretsByType;
};

export const getTopSessionTypes = async () => {
  return dummyData.topSessionTypes;
};

export const getMFAFactors = async () => {
  return dummyData.mfaFactors;
};

export const getUsersWithLogonScript = async (
  mappedLogonFilters: Record<string, string>,
  sub_source: string[],
  signal?: AbortSignal,
) => {
  const payload = {
    sub_source: sub_source || [],
    filter_user: mappedLogonFilters,
  };
  const response = await axiosInstanceFast.post(
    "/user/users-with-logon-scripts",
    payload,
    { signal },
  );
  return response.data;
};

export const updateGroupCriticalStatus = async (
  data: any,
  signal?: AbortSignal,
) => {
  const response = await axiosInstanceFast.post("/groups/insert-groups", data, {
    signal,
  });
  return response.data.data;
};

export const userGroupDetails = async (
  data: { uid: string; plugin_id: string },
  signal?: AbortSignal,
) => {
  const response = await axiosInstanceFast.post(
    "/groups/groups-list-for-user",
    data,
    { signal },
  );
  return response.data.data;
};
